var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "column",
      class: {
        "column--disabled": _vm.disabled,
      },
    },
    [
      _c("label", { staticClass: "item", on: { click: _vm.onClick } }, [
        _c(
          "div",
          {
            staticClass: "item-checkbox",
            class: {
              "item-checkbox_check": _vm.checked.toString() === "1",
              "item-checkbox_half": _vm.checked.toString() === "2",
            },
          },
          [
            _c(
              "svg",
              {
                staticClass: "item-checkbox-value item-checkbox-value_check",
                attrs: {
                  width: "11",
                  height: "8",
                  viewBox: "0 0 11 8",
                  xmlns: "http://www.w3.org/2000/svg",
                },
              },
              [
                _c("path", {
                  attrs: {
                    d: "M3.29312 7.6838C2.90259 7.29327 2.90259 6.66011 3.29312 6.26958L8.29712 1.26555C8.68764 0.875025 9.32081 0.875025 9.71133 1.26555C10.1019 1.65607 10.1019 2.28924 9.71133 2.67976L4.70733 7.6838C4.31681 8.07432 3.68364 8.07432 3.29312 7.6838Z",
                  },
                }),
                _c("path", {
                  attrs: {
                    d: "M4.70733 7.6838C5.09786 7.29327 5.0978 6.66011 4.70727 6.26958L1.73445 3.29679C1.34393 2.90626 0.710761 2.90626 0.320237 3.29679C-0.0702873 3.68731 -0.0702873 4.32048 0.320237 4.711L3.29312 7.6838C3.68364 8.07432 4.31681 8.07432 4.70733 7.6838Z",
                  },
                }),
              ]
            ),
            _c("div", {
              staticClass: "item-checkbox-value item-checkbox-value_square",
            }),
          ]
        ),
        _c("div", {
          staticClass: "item-label",
          domProps: { innerHTML: _vm._s(_vm.name) },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }